import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { StateStructure } from '@ptl/state';
import { NgRedux } from '@ptl/angular-redux-store';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { EffectiveDateStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/effective-date.state-structure.interface';
import { environment } from 'src/environments/environment';
import { GetProductTypesResponse, ProductGroupInfo } from 'src/app/angular-elements/plan-selection/interfaces/get-product-types.interfaces';
import { plansNeedRefreshedFromBackend, saveProductGroupsForCounty } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';
import { PRODUCT_GROUPS, PRODUCT_GROUP_NAMES } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { PtlWindowLocationService } from '@ptl/global-components';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductTypeTabService {

  public productTypesReturnedSubject: Subject<GetProductTypesResponse> = new Subject<GetProductTypesResponse>();
  productTypesReturned$: Observable<GetProductTypesResponse> = this.productTypesReturnedSubject.asObservable();

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private ngRedux: NgRedux<StateStructure>,
    private httpClient: HTTPWrapperContext,
    private windowLocationService: PtlWindowLocationService
  ) { }


  async retrieveProductTypes(market = 'Senior', productTabs?: PRODUCT_GROUP_NAMES[]): Promise<GetProductTypesResponse> {
    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');
    const effectiveDateState: EffectiveDateStateStructure = this.reducerUtilityService.getReducerFromApplicationState('EffectiveDate');

    const aspId = environment.initData.brand.ASPID;
    const county = zipCountyState.county && zipCountyState.county.county;
    const year = effectiveDateState.effectiveDateYear;
    const planRegion = zipCountyState.county && zipCountyState.county.region;

    let payloadMissing = '';
    if (!aspId) {
      payloadMissing += 'ASP\n';
    }
    if (!county) {
      payloadMissing += 'County\n';
    }
    if (!year) {
      payloadMissing += 'Year\n';
    }
    if (!market) {
      payloadMissing += 'Market\n';
    }
    if (!planRegion) {
      payloadMissing += 'planRegion\n';
    }

    if (!payloadMissing) {
      const productsResponse: GetProductTypesResponse = await this.getProductsAvailableForCounty(aspId, market, year, county, planRegion);
      if (!(productsResponse instanceof HttpErrorResponse)) {
        let productGroupsToLoad: ProductGroupInfo = productsResponse?.productGroups;

        if (Array.isArray(productTabs) && productTabs.length > 0) {

          // Reset the ProductsGroups as we need to set new matching products as per config and response
          productGroupsToLoad = {};

          productTabs.forEach(productConfigExists => {
            if (productsResponse.productGroups[productConfigExists]) {
              productGroupsToLoad[productConfigExists] = productsResponse.productGroups[productConfigExists];
            }
          });
        }

        if (Object.keys(productGroupsToLoad).length > 0) {
          this.ngRedux.dispatch(saveProductGroupsForCounty(productGroupsToLoad));
        } else {
          this.ngRedux.dispatch(saveProductGroupsForCounty(null));
          this.ngRedux.dispatch(plansNeedRefreshedFromBackend(false));
        }
      }

      this.productTypesReturnedSubject.next(productsResponse);
      return productsResponse;
    }

    console.error('Missing necessary data. One of:\n' + payloadMissing);

  }

  getProductsAvailableForCounty(
    aspId: string,
    market: string,
    year: string,
    county: string,
    planRegion: string): Promise<GetProductTypesResponse> {

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: `/getProducts/products/${aspId}/${market}/${year}`,
        GET_PAYLOAD: {
        COUNTY: county,
        PLAN_REGION: planRegion
      }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.GOOGLE_CLOUD);
    var response = this.httpClient.makeRequest<GetProductTypesResponse>(requestConfig).catch((fail) => fail);
    return response;
  }

  getImageForProductType(productTypeTabConfig, productType: PRODUCT_GROUPS) {

    const matchedConfigObjectArray = productTypeTabConfig?.filter(config => {
      return config.productType.toUpperCase() === productType.toUpperCase();
    });

    return matchedConfigObjectArray[0]?.type_fileReference;
  }

  getProductTypeFromURL(): PRODUCT_GROUPS {
    const queryParams = this.windowLocationService.getParsedQueryParams();

    if (queryParams.hasOwnProperty('planType')) {
      return decodeURIComponent(queryParams['planType']) as PRODUCT_GROUPS;
    }

    return null;
  }


}
